module.exports = __webpack_public_path__ + "img/unlock-solid 1.c2d6d704.svg";